<div class="a-form-checkbox-radio-field">
  <div class="input_label">
    <input [type]="type" [id]="(value.value || value.label || value)  + (id || '')" [value]="value" [name]="name + id"
      [checked]="checked" (change)="onSelectionChange($event.target.checked, value)" />
    <label [for]="(value.value || value.label || value)  + (id || '')" [innerHTML]="label"></label>
  </div>
  <div *ngIf="description" class="description">
    {{ description}}
  </div>
</div>